/**
 * The frame both rail pages sit in: sidebar, top bar, content column.
 *
 * My Day and the admin home had the same wrapper copied into each — the flex
 * row, the rail, the padding AppLayout no longer applies on these routes. A
 * top bar landing on both was the point at which a third copy would have been
 * one too many, so the arrangement lives here and the pages pass their content.
 *
 * **This is not the shell's header coming back.** AppLayout still renders
 * nothing on these routes, and every other page still gets the top bar it
 * always had, unchanged. This strip belongs to the rail pages, carries
 * different things, and exists only where the rail does.
 */
import DashboardSidebar from './DashboardSidebar';
import DashboardTopBar from './DashboardTopBar';

export default function DashboardShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-full">
      <DashboardSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <DashboardTopBar />
        {/* The padding AppLayout does not apply on a rail route. It lives here
            so the rail beside it stays flush to the edge. */}
        <div className="min-w-0 flex-1 space-y-5 px-5 py-6">{children}</div>
      </div>
    </div>
  );
}
